// Button: when something presses it, its action (act) runs, e.g. cut a rope (act.cut) or the world's act.fire
import { defineObj } from '../core/registry';
import { rr, lg, shadowOn, shadowOff, C, DEG } from '../core/draw-helpers';
import type { Act, Ctx2D, GameBody } from '../core/types';
import { drawRope } from './rope';
import { drawStone } from './stone';

export interface Button { x: number; y: number; a: number; sens: GameBody; on: boolean; act?: Act; pressT: number }
declare module '../core/types' { interface SimState { buttons: Button[] } }

export function drawButton(ctx: Ctx2D, B: { x: number; y: number; a?: number; on: boolean }) {
  ctx.save(); ctx.translate(B.x, B.y); ctx.rotate((B.a || 0) * DEG);
  shadowOn(ctx, 8, 4); rr(ctx, -30, 1, 60, 14, 5); ctx.fillStyle = lg(ctx, 1, 15, '#8B84A0', '#5E5773'); ctx.fill(); shadowOff(ctx);
  const h = B.on ? 4 : 13;
  ctx.beginPath(); ctx.ellipse(0, 2, 20, h, 0, Math.PI, 0); ctx.fillStyle = B.on ? '#3FCB6B' : C.red2; ctx.fill();
  ctx.beginPath(); ctx.ellipse(-6, 2 - h * 0.55, 6, h * 0.25, -0.3, 0, 7); ctx.fillStyle = 'rgba(255,255,255,.55)'; ctx.fill();
  ctx.restore();
}

export const button = defineObj({
  phase: 'core', layer: 'back', z: -1, thumb: 2,
  create(api, o) {
    const { add, R } = api, a = (o.a as number) || 0;
    const base = add(R(o.x, o.y + 8, 60, 14, { isStatic: true, chamfer: { radius: 4 }, angle: a * DEG }));
    base.kind = 'buttonbase';
    const sens = add(R(o.x, o.y - 6, 44, 18, { isStatic: true, isSensor: true, angle: a * DEG }));
    sens.kind = 'buttonsens';
    const B: Button = { x: o.x, y: o.y, a, sens, on: false, act: o.act as Act | undefined, pressT: 0 };
    api.S.buttons.push(B);
    return B;
  },
  draw: (ctx, st) => drawButton(ctx, st),
  blockers: o => [{ x: o.x, y: o.y, r: 34 }],
  system: {
    init: api => { api.S.buttons = []; },
    contact: {
      buttonsens(api, x, y) {
        const S = api.S;
        if (!api.isDynamic(y)) return;
        const btn = S.buttons.find(k => k.sens === x);
        if (btn && !btn.on) { btn.on = true; btn.pressT = S.t; S.events.push({ e: 'click', x: btn.x, y: btn.y }); api.act(btn.act); }
      },
    },
  },
  intro(x, t, g, { fakeBall, arrow }) {
    const B = { x: 120, y: 214, on: t > 60 };
    g.block(x, 120, 236, 200, 16, 0, '#F7B267', '#D9803E', 8);
    drawButton(x, B);
    const bx = t < 60 ? 10 + t * 1.8 : 118;
    g.ball(x, fakeBall(bx, t < 60 ? 212 : 196, t < 60 ? 3 : 0, 0), 'helper', t);
    const cut = t > 70;
    const R = { ax: 340, ay: 30, cut, cutT: 70, body: { position: { x: 340, y: cut ? Math.min(230, 150 + 0.06 * (t - 70) * (t - 70)) : 150 }, circleRadius: 24 } };
    drawRope(x, R, t);
    drawStone(x, 340, R.body.position.y, 0);
    arrow(250, 120, 250, 60, true);
  },
});
